import React from 'react';
import { Badge } from '@/components/ui/badge';

export type ChannelFlags = {
    notifyInApp?: number | boolean;
    notifyEmail?: number | boolean;
    notifyWebPush?: number | boolean;
};

export const ChannelBadges = ({ item }: { item: ChannelFlags }) => (
    <div className="flex flex-wrap gap-2">
        {Boolean(item.notifyInApp) && <Badge variant="secondary">In app</Badge>}
        {Boolean(item.notifyEmail) && <Badge variant="secondary">Email</Badge>}
        {Boolean(item.notifyWebPush) && <Badge variant="secondary">Web push</Badge>}
        {!item.notifyInApp && !item.notifyEmail && !item.notifyWebPush && <Badge variant="outline">No reminder</Badge>}
    </div>
);
